export const UPDATE_QUESTIONNAIRE = 'questionnaire/UPDATE_QUESTIONNAIRE';
export const POPULATE_QUESTIONNAIRE = 'questionnaire/POPULATE_QUESTIONNAIRE';
export const POPULATE_QUESTIONNAIRE_FROM_BACKEND =
  'questionnaire/POPULATE_QUESTIONNAIRE_FROM_BACKEND';
export const NAVIGATE_TO_STEP = 'questionnaire/NAVIGATE_TO_STEP';
export const ERASE_ANSWERS_AFTER_STEP =
  'questionnaire/ERASE_ANSWERS_AFTER_STEP';
export const FIELD_SAVER = 'questionnaire/FIELD_SAVER';
